<div class="d-flex border-end">
  <!-- Vertical Tab Navigation -->
  <div class="nav-tabs-mini nav flex-column nav-pills" id="v-pills-tab" role="tablist" aria-orientation="vertical">
    <a class="nav-link text-center" :class="{ active: activeTab === 'your_feed' }" id="normal_loans_tab_md" data-bs-toggle="pill"
                      data-bs-target="#normal_loans_info" type="button" role="tab" aria-controls="normal_loans_info"
                      aria-selected="true" @click="activeTab = 'your_feed'">
      <i class="bi bi-pencil-square"></i>
      <p class="text-xxs">Feed</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'voice' }" id="top_loans_tab_md" data-bs-toggle="pill"
                      data-bs-target="#top_loans_info" type="button" role="tab" aria-controls="top_loans_info"
                      aria-selected="false" @click="activeTab = 'voice'">
      <i class='bx bxs-user-voice'></i>
      <p class="text-xxs">Voice</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'discussions' }" id="documen_approval_md" data-bs-toggle="pill"
                      data-bs-target="#discussions" type="button" role="tab" aria-controls="portal_members"
                      aria-selected="true" @click="activeTab = 'discussions'">
      <i class="bi bi-chat-left-quote"></i>
      <p class="text-xxs">Forum</p>
    </a>
    <a class="nav-link text-center"  :class="{ active: activeTab === 'requests' }" id="portal_requests_md" data-bs-toggle="pill"
                      data-bs-target="#portal_requests" type="button" role="tab" aria-controls="portal_requests"
                      aria-selected="true" @click="activeTab = 'requests'">
      <i class="bi bi-person-fill-lock"></i>
      <p class="text-xxs">Requests</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'members' }" id="portal_members_md" data-bs-toggle="pill"
                      data-bs-target="#portal_members" type="button" role="tab" aria-controls="portal_members"
                      aria-selected="true" @click="activeTab = 'members'">
      <i class="bi bi-people"></i>
      <p class="text-xxs">Members</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'events' }" id="normal_loans_tab_md" data-bs-toggle="pill"
                      data-bs-target="#events" type="button" role="tab" aria-controls="events"
                      aria-selected="true" @click="activeTab = 'events'">
      <i class="bi bi-calendar-event"></i>
      <p class="text-xxs">Events</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'documents' }" id="documen_approval_md" data-bs-toggle="pill"
                      data-bs-target="#document_approval" type="button" role="tab" aria-controls="portal_members"
                      aria-selected="true" @click="activeTab = 'documents'">
      <i class="bi bi-three-dots"></i>
      <p class="text-xxs">Document Approval</p>
    </a>
    <a class="nav-link text-center" :class="{ active: activeTab === 'documents_warehouse' }" id="documen_approval_md" data-bs-toggle="pill"
                      data-bs-target="#documents_warehouse" type="button" role="tab" aria-controls="portal_members"
                      aria-selected="true" @click="activeTab = 'documents_warehouse'">
      <i class="bi bi-file-earmark-pdf"></i>
      <p class="text-xxs">Document Warehouse</p>
    </a>
  </div>
</div>
